module.exports = __webpack_public_path__ + "img/avemio.tech.82b29475.svg";